export default __webpack_public_path__ + "static/media/appframe.f6fb314e.svg";